/**
 * Header wishlist icon — count badge + link to /pages/wishlist
 */
(() => {
  function sync(btn) {
    if (!window.OCWishlist || !btn) return;
    const count = window.OCWishlist.count();
    btn.classList.toggle('has-items', count > 0);
    btn.setAttribute('data-wishlist-count', String(count));

    let badge = btn.querySelector('[data-wishlist-count-badge]');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'header-actions__wishlist-count';
        badge.setAttribute('data-wishlist-count-badge', '');
        badge.setAttribute('aria-hidden', 'true');
        btn.appendChild(badge);
      }
      badge.textContent = count > 99 ? '99+' : String(count);
    } else if (badge) {
      badge.remove();
    }
  }

  function init() {
    const btn = document.querySelector('.header-actions__wishlist');
    if (!btn || !window.OCWishlist) return;
    sync(btn);
    document.addEventListener(window.OCWishlist.CHANGE, () => sync(btn));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
